import {
  EyeInvisibleOutlined,
  EyeOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Button, Card, Divider, Form, Input, InputNumber, Select, Space, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { commaSeparateNumber, isArrayAndHasValue } from "utils/functions";
import {
  ADD_EXPORT_GOODS_DESCRIPTION,
  EXPORT_DETAIL_GOODS_DESCRIPTIONS_LIST,
  GET_PO_INFO,
} from "../../../../../apiServices/API_ENDPOINTS";
import { getData, postData } from "../../../../../apiServices/common";
import { alertPop } from "../../../../../apiServices/common/helper";
import HandleNotification from "../../../../../common/Notification";
import "../../../../PurchaseOrder/AddOrUpdateStyle/POTable.css";

const ExportPOTable = (props) => {
  // Props
  const {
    poDetailsData,
    salesContractDetails,
    setPoDetailsData,
    poDetailsForm,
    salesContractId,
    form,
    lcdetailsList,
    setLcdetailsList,
    isView,
    // poFilesList,
    // setPoFilesList
  } = props;

  const isEditMode = !!props.editMode;

  const [currentRole, setCurrentRole] = useState(
    localStorage.getItem("roleInfo") ? JSON.parse(localStorage.getItem("roleInfo")) : null,
  );

  // Antd
  const { Option } = Select;
  const { exportDetailId } = useParams();
  const [addedGoodsDescription, setAddedGoodsDescription] = useState(null);
  const [goodsDescriptions, setGoodsDescription] = useState(null);
  const [subStyle, setSubStyle] = useState([]);
  const [mergedSubStyles, setMergedSubStyles] = useState([]);
  const [hasSubStyles, setHasSubStyles] = useState(false);
  const [showColorSizeColumns, setShowColorSizeColumns] = useState(false);

  // clolor and size
  const [colorOptions, setColorOptions] = useState({});
  const [sizeOptions, setSizeOptions] = useState({});

  const resetColorAndSizeSelections = () => {
    const formValues = poDetailsForm.getFieldsValue();
    const totalRows = Array.isArray(poDetailsData) ? poDetailsData.length : 0;

    const updatedColorList = Array.from({ length: totalRows }, (_, idx) => {
      const currentEntry =
        Array.isArray(formValues?.color_list) && formValues.color_list[idx] ? formValues.color_list[idx] : {};
      return { ...currentEntry, color_id: null };
    });

    const updatedSizeList = Array.from({ length: totalRows }, (_, idx) => {
      const currentEntry =
        Array.isArray(formValues?.size_list) && formValues.size_list[idx] ? formValues.size_list[idx] : {};
      return { ...currentEntry, size_id: null };
    });

    if (totalRows) {
      poDetailsForm.setFieldsValue({
        color_list: updatedColorList,
        size_list: updatedSizeList,
      });
    }

    if (Array.isArray(poDetailsData) && typeof setPoDetailsData === "function") {
      const resetData = poDetailsData.map((item) => ({
        ...item,
        color_id: null,
        size_id: null,
      }));
      setPoDetailsData(resetData);
    }
  };

  const toggleColorSizeColumns = () => {
    setShowColorSizeColumns((prev) => {
      if (prev) {
        resetColorAndSizeSelections();
      }
      return !prev;
    });
  };

  useEffect(() => {
    if (isEditMode && Array.isArray(poDetailsData)) {
      const shouldShowColumns = poDetailsData.some((item) => {
        const hasColor = item?.color_id !== null && item?.color_id !== undefined && item?.color_id !== "";
        const hasSize = item?.size_id !== null && item?.size_id !== undefined && item?.size_id !== "";
        return hasColor || hasSize;
      });

      if (shouldShowColumns && !showColorSizeColumns) {
        setShowColorSizeColumns(true);
      }
    }
  }, [isEditMode, poDetailsData, showColorSizeColumns]);

  const api_base_url = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("token");

  const getDescriptionsList = async (filterValues) => {
    const query = `${EXPORT_DETAIL_GOODS_DESCRIPTIONS_LIST}`;
    const bodyData = {
      ...filterValues,
      description: filterValues?.description || "",
      per_page: filterValues?.per_page || 10000,
    };

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setGoodsDescription(response?.data?.data);
    }
  };

  useEffect(() => {
    getDescriptionsList();
  }, []);

  const onGoodsDescriptionChange = (event) => {
    setAddedGoodsDescription(event.target.value);
  };

  // const onChangeFileUpload = (info, index) => {
  //   if (info.file.status === 'done' && info.file.response.code === 200) {
  //     const response = info.file.response.data;
  //     const newFilesList = [...poFilesList];
  //     newFilesList[index] = response.id;
  //     setPoFilesList(newFilesList);

  //     // Update the document property of the corresponding obj in poDetailsData
  //     const updatedPoDetailsData = [...poDetailsData];
  //     updatedPoDetailsData[index].document = response.document;
  //     setPoDetailsData(updatedPoDetailsData);
  //   }
  // };

  const addNewGoodsDescription = async (event) => {
    event.preventDefault();
    const query = `${ADD_EXPORT_GOODS_DESCRIPTION}`;
    const bodyData = {
      goods_description: addedGoodsDescription,
      export_detail_id: exportDetailId ? Number(exportDetailId) : null,
    };

    const response = await postData(query, bodyData);

    if (response && response?.code === 200) {
      setAddedGoodsDescription(null);
      HandleNotification("success", "Reason added successfully");
      getDescriptionsList();
    }
  };

  const onChangeLCValue = (value, index, keyName) => {
    // Check if setLcdetailsList is a function before using it
    if (typeof setLcdetailsList !== "function") {
      console.warn("setLcdetailsList is not a function. Skipping LC value update.");
      return;
    }

    // Initialize lcdetailsList if it doesn't exist or isn't an array
    const currentLcdetailsList = Array.isArray(lcdetailsList) ? lcdetailsList : [];

    // Copy lcdetailsList state array
    const lcDetailsDataCopy = [...currentLcdetailsList];

    // Find the item with the matching unique_id
    const foundLCItem = lcDetailsDataCopy.find((item) => item?.unique_id === index);

    // If item doesn't exist, create it
    if (!foundLCItem) {
      const newItem = { unique_id: index };
      newItem[keyName] = value;
      lcDetailsDataCopy.push(newItem);
    } else {
      foundLCItem[keyName] = value;
    }

    // Now it's safe to call setLcdetailsList
    setLcdetailsList(lcDetailsDataCopy);
  };

  const copyRow = (index) => {
    const newData = [...poDetailsData];
    // const newFilesList = [...poFilesList];
    // newFilesList.push(null);
    newData.push({
      unique_id: newData[newData.length - 1].unique_id + 1,
    });

    setPoDetailsData(newData);
    // setPoFilesList(newFilesList);
  };

  const getPOInfo = async (
    sales_contract_id,
    po_map_id,
    style_id,
    sub_style_id = 0,
    index,
    color_id = null,
    size_id = null,
  ) => {
    const bodyData = {
      sales_contract_id,
      po_map_id,
      style_id,
      sub_style_id: style_id === sub_style_id ? 0 : sub_style_id,
      color_id,
      size_id,
    };

    //const response = await getData(GET_PO_INFO, false, bodyData);
    const response = await postData(`${GET_PO_INFO}`, bodyData);

    if (response && response?.code === 200) {
      const masterData = response?.data;

      setColorOptions((prev) => ({
        ...prev,
        [index]: masterData.colors || [],
      }));
      setSizeOptions((prev) => ({ ...prev, [index]: masterData.sizes || [] }));

      const formValues = poDetailsForm.getFieldsValue();

      // Same calculation as onChangeShipQty
      const shipQty = Number(masterData?.ship_qty || 0);
      const orderQty = Number(masterData?.sales_order_qty || 0);
      const unitPrice = Number(masterData?.unit_price || 0);
      const calculatedShipValue = shipQty * unitPrice;
      const calculatedBalanceQty = shipQty - orderQty;
      const calculatedBalanceValue = calculatedBalanceQty * unitPrice;

      // Change po details form values
      formValues.sales_order_qty_list[index]["sales_order_qty"] = masterData?.sales_order_qty;
      formValues.carton_qty_list[index].carton_qty = masterData?.carton_qty;
      formValues.unit_price_list[index].unit_price = masterData?.unit_price;
      formValues.ship_qty_list[index].ship_qty = masterData?.ship_qty;
      formValues.goods_description_list[index].goods_description = masterData?.goods_description;
      formValues.ship_qty_unit_list[index].ship_qty_unit = masterData?.ship_qty_unit;
      formValues.ship_value_list[index].ship_value = calculatedShipValue
        ? parseFloat(calculatedShipValue.toFixed(2))
        : 0;
      formValues.balance_qty_list[index].balance_qty = calculatedBalanceQty;
      formValues.balance_qty_unit_list[index].balance_qty_unit = masterData?.balance_qty_unit;
      formValues.balance_value_list[index].balance_value = calculatedBalanceValue
        ? parseFloat(calculatedBalanceValue.toFixed(2))
        : 0;

      if (formValues.export_po_map_doc_lists) {
        formValues.export_po_map_doc_lists[index].document = masterData?.document;
      }

      if (!formValues.color_list) formValues.color_list = [];
      if (!formValues.size_list) formValues.size_list = [];
      formValues.color_list[index] = { color_id: color_id || "" };
      formValues.size_list[index] = { size_id: size_id || "" };

      poDetailsForm.setFieldsValue(formValues);
    } else {
      alertPop("error", response?.messages ? response?.messages : "Something Went Wrong!");
    }
  };

  const onColorChange = (value, index) => {
    const formValues = poDetailsForm.getFieldsValue();
    formValues.color_list[index] = { color_id: value };
    poDetailsForm.setFieldsValue(formValues);

    // Get current PO/style/sub-style/size
    const po_map_id = formValues.po_numbers_list[index]?.po_map_id;
    const style_id = formValues.style_numbers_list[index]?.style_id;
    const sub_style_id = formValues.sub_style_numbers_list?.[index]?.sub_style_id || 0;
    const size_id = formValues.size_list?.[index]?.size_id || null;

    getPOInfo(salesContractId, po_map_id, style_id, sub_style_id, index, value, size_id);
  };

  const onClearColor = (index) => {
    const formValues = poDetailsForm.getFieldsValue();
    formValues.color_list[index] = { color_id: null };
    poDetailsForm.setFieldsValue(formValues);

    const po_map_id = formValues.po_numbers_list[index]?.po_map_id;
    const style_id = formValues.style_numbers_list[index]?.style_id;
    const sub_style_id = formValues.sub_style_numbers_list?.[index]?.sub_style_id || 0;
    const size_id = formValues.size_list?.[index]?.size_id || null;

    getPOInfo(salesContractId, po_map_id, style_id, sub_style_id, index, null, size_id);
  };

  const onSizeChange = (value, index) => {
    const formValues = poDetailsForm.getFieldsValue();
    formValues.size_list[index] = { size_id: value };
    poDetailsForm.setFieldsValue(formValues);

    const po_map_id = formValues.po_numbers_list[index]?.po_map_id;
    const style_id = formValues.style_numbers_list[index]?.style_id;
    const sub_style_id = formValues.sub_style_numbers_list?.[index]?.sub_style_id || 0;
    const color_id = formValues.color_list?.[index]?.color_id || null;

    getPOInfo(salesContractId, po_map_id, style_id, sub_style_id, index, color_id, value);
  };

  const onClearSize = (index) => {
    const formValues = poDetailsForm.getFieldsValue();
    formValues.size_list[index] = { size_id: null };
    poDetailsForm.setFieldsValue(formValues);

    const po_map_id = formValues.po_numbers_list[index]?.po_map_id;
    const style_id = formValues.style_numbers_list[index]?.style_id;
    const sub_style_id = formValues.sub_style_numbers_list?.[index]?.sub_style_id || 0;
    const color_id = formValues.color_list?.[index]?.color_id || null;

    getPOInfo(salesContractId, po_map_id, style_id, sub_style_id, index, color_id, null);
  };

  const qtyUnit = [
    { id: 1, name: "Piece" },
    { id: 2, name: "Dozen" },
    { id: 3, name: "Blister" },
  ];

  const removeRow = (unique_id) => {
    const newData = [...poDetailsData];
    // const newFilesList = [...poFilesList];

    // If only item remains then don't delete
    // if (newData.length === 1) {
    //   return;
    // }

    // Find index and delete item
    const index = newData.findIndex((item) => item.unique_id === unique_id);
    if (index > -1) {
      // Before removing, also remove the corresponding form field values
      const formValues = poDetailsForm.getFieldsValue();

      // List of all form field arrays that need to be updated
      const fieldArrays = [
        "po_numbers_list",
        "style_numbers_list",
        "sub_style_numbers_list",
        "goods_description_list",
        "carton_qty_list",
        "sales_order_qty_list",
        "unit_price_list",
        "ship_qty_list",
        "ship_qty_unit_list",
        "ship_value_list",
        "balance_qty_list",
        "balance_qty_unit_list",
        "balance_value_list",
      ];

      // Remove the item at the found index from each form field array
      fieldArrays.forEach((fieldName) => {
        if (Array.isArray(formValues[fieldName])) {
          formValues[fieldName].splice(index, 1);
        }
      });

      // Set the updated form values
      poDetailsForm.setFieldsValue(formValues);

      // Remove the item from poDetailsData
      newData.splice(index, 1);
    }

    setPoDetailsData(newData);

    // Recalculate totals after deletion
    setTimeout(() => {
      const updatedFormValues = poDetailsForm.getFieldsValue();

      // Calculate total carton quantity
      const totalCartonQuantity = updatedFormValues?.carton_qty_list?.reduce(
        (acc, item) => acc + Number(item?.carton_qty || 0),
        0,
      );

      // Calculate total shipped quantity
      const totalQuantity = updatedFormValues?.ship_qty_list?.reduce(
        (acc, item) => acc + Number(item?.ship_qty || 0),
        0,
      );

      // Calculate total invoice value
      const invoiceValue = updatedFormValues?.ship_value_list?.reduce(
        (acc, item) => acc + Number(item?.ship_value || 0),
        0,
      );

      // Update the main form with new totals
      form.setFieldsValue({
        carton_quantity: totalCartonQuantity,
        total_quantity: totalQuantity,
        invoice_value: invoiceValue,
      });
    }, 100);
  };

  const onSelectStyle = (value, index, source = "style") => {
    const formValues = poDetailsForm.getFieldsValue();

    // Initialize sub_style_numbers_list if needed
    if (!formValues.sub_style_numbers_list) {
      formValues.sub_style_numbers_list = [];
    }

    // Ensure the index exists
    if (!formValues.sub_style_numbers_list[index]) {
      formValues.sub_style_numbers_list[index] = { sub_style_id: null };
    }

    if (source === "sub-style") {
      // If selecting from sub-styles dropdown
      const subStyle = mergedSubStyles.find((s) => s.id.toString() === value.toString());

      if (subStyle) {
        // Set the parent style_id
        formValues.style_numbers_list[index].style_id = subStyle.parent_style_id;
        // Set the sub_style_id
        formValues.sub_style_numbers_list[index].sub_style_id = subStyle.id;

        poDetailsForm.setFieldsValue(formValues);

        // Call getPOInfo with parent style ID
        const po_map_id = formValues.po_numbers_list[index].po_map_id;
        if (po_map_id || po_map_id === 0) {
          getPOInfo(salesContractId, po_map_id, subStyle.parent_style_id, subStyle.id, index);
        }

        // Get sub-styles for this style
        getSubstyle(subStyle.parent_style_id);
      }
    } else {
      // Original behavior for style selection
      formValues.style_numbers_list[index].style_id = value;
      formValues.sub_style_numbers_list[index].sub_style_id = null;

      poDetailsForm.setFieldsValue(formValues);

      const po_map_id = formValues.po_numbers_list[index].po_map_id;
      if (po_map_id || po_map_id === 0) {
        getPOInfo(salesContractId, po_map_id, value, null, index);
      }

      // Get sub-styles for this style
      getSubstyle(value);
    }
  };

  const onChangeCartonQty = (e, index) => {
    const formValues = poDetailsForm.getFieldsValue();

    const totalCartonQuantity = formValues?.carton_qty_list?.reduce((acc, item) => acc + Number(item?.carton_qty), 0);
    form.setFieldsValue({ carton_quantity: totalCartonQuantity });
  };

  const onChangeShipQty = (value, index) => {
    const formValues = poDetailsForm.getFieldsValue();

    // Input Values
    const shipQtyInput = value;
    const orderQty = formValues?.sales_order_qty_list[index]?.sales_order_qty;
    const unitPrice = formValues?.unit_price_list[index]?.unit_price;

    // Calculated Values
    const calculated_ship_value = shipQtyInput * unitPrice;
    const calculated_balance_qty = shipQtyInput - orderQty;
    const calculated_balance_value = calculated_balance_qty * unitPrice;

    const calculated_ship_value_formatted = calculated_ship_value ? parseFloat(calculated_ship_value.toFixed(2)) : 0;
    const calculated_balance_value_formatted = calculated_balance_value
      ? parseFloat(calculated_balance_value.toFixed(2))
      : 0;

    // Assing Values to form fields
    formValues.ship_value_list[index].ship_value = calculated_ship_value_formatted;
    formValues.balance_qty_list[index].balance_qty = calculated_balance_qty;
    formValues.balance_value_list[index].balance_value = calculated_balance_value_formatted;
    poDetailsForm.setFieldsValue(formValues);

    // Calculate total quantity and invoice value for main form
    const totalQuantity = formValues?.ship_qty_list?.reduce((acc, item) => acc + Number(item?.ship_qty), 0);
    const invoiceValue = formValues?.ship_value_list?.reduce((acc, item) => acc + Number(item?.ship_value), 0);

    // Set form values
    form.setFieldsValue({ total_quantity: totalQuantity });
    form.setFieldsValue({ invoice_value: invoiceValue });
  };

  const onSelectShipmentUnit = (value, index) => {
    const formValues = poDetailsForm.getFieldsValue();
    const balance_qty_unit_list = formValues?.balance_qty_unit_list;
    balance_qty_unit_list[index].balance_qty_unit = value;
    poDetailsForm.setFieldsValue({
      balance_qty_unit_list: balance_qty_unit_list,
    });
  };

  const getSubstyle = async (value) => {
    //const cutting_date_watch = Form.useWatch("cutting_date", form);

    let res = await getData(`/api/getSubStyle/${value}`);
    if (res) {
      setSubStyle(res?.data?.data);
    }
  };

  const getSubstyleList = (index) => {
    // Get all form values
    const poDetailsFormValues = poDetailsForm.getFieldsValue();
    const style_obj = poDetailsFormValues?.style_numbers_list?.[index];
    const style_id = style_obj?.style_id;
    const foundStyleItem = salesContractDetails?.styleDetail?.find((item) => item?.style_info?.id === style_id);
    const sub_style_list = foundStyleItem?.style_info?.sub_style_map;

    return isArrayAndHasValue(sub_style_list) ? sub_style_list : [];
  };

  const openFileInNewTab = (file_url) => {
    const url = `${api_base_url}/${file_url}`;
    window.open(url, "_blank");
  };

  useEffect(() => {
    console.log(salesContractDetails);
    if (salesContractDetails?.styleDetail?.length) {
      // Check if any style has sub-styles
      let anySubStyles = false;
      const allSubStyles = [];

      salesContractDetails.styleDetail.forEach((style) => {
        if (style?.style_info?.sub_style_map?.length) {
          // If style has sub-styles, add them to the dropdown
          anySubStyles = true;

          // For each sub-style, add parent style info
          style.style_info.sub_style_map.forEach((subStyle) => {
            allSubStyles.push({
              ...subStyle,
              parent_style_id: style.style_id,
              parent_style_no: style.style_info.style_no,
              parent_style_description: style.style_info.description,
            });
          });
        } else {
          // If style doesn't have sub-styles, add the parent style itself to the list
          allSubStyles.push({
            id: style.style_id,
            sub_style_no: style.style_info.style_no,
            parent_style_id: style.style_id,
            parent_style_no: style.style_info.style_no,
            parent_style_description: style.style_info.description,
          });
        }
      });

      setHasSubStyles(anySubStyles);
      setMergedSubStyles(allSubStyles);
    }
  }, [salesContractDetails]);

  // Add new function to check and set balance qty when PO is selected
  const onSelectPO = (value, index) => {
    setTimeout(() => {
      const formValues = poDetailsForm.getFieldsValue();
      const currentStyle = formValues.style_numbers_list[index]?.style_id;

      if (currentStyle) {
        checkAndSetBalanceQty(value, currentStyle, index);
      }
    }, 100);
  };

  const onStyleChange = (value, index, source) => {
    onSelectStyle(value, index, source);

    setTimeout(() => {
      const formValues = poDetailsForm.getFieldsValue();
      const currentPO = formValues.po_numbers_list[index]?.po_map_id;

      if (currentPO) {
        checkAndSetBalanceQty(currentPO, value, index);
      }
    }, 200);
  };

  const checkAndSetBalanceQty = (poId, styleId, targetIndex) => {
    const formValues = poDetailsForm.getFieldsValue();
    const targetSubStyle = formValues.sub_style_numbers_list?.[targetIndex]?.sub_style_id;

    let matchingRows = [];

    for (let i = 0; i < targetIndex; i++) {
      const rowPo = formValues.po_numbers_list[i]?.po_map_id;
      const rowStyle = formValues.style_numbers_list[i]?.style_id;
      const rowSubStyle = formValues.sub_style_numbers_list?.[i]?.sub_style_id;

      if (rowPo === poId && rowStyle === styleId) {
        if ((targetSubStyle && rowSubStyle === targetSubStyle) || (!targetSubStyle && !rowSubStyle)) {
          matchingRows.push(i);
        }
      }
    }

    if (matchingRows.length > 0) {
      const mostRecentRowIndex = Math.max(...matchingRows);

      const balanceQty = formValues.balance_qty_list[mostRecentRowIndex]?.balance_qty;
      const unitPrice = formValues.unit_price_list[mostRecentRowIndex]?.unit_price;
      const balanceQtyUnit = formValues.balance_qty_unit_list[mostRecentRowIndex]?.balance_qty_unit;

      if (balanceQty) {
        formValues.sales_order_qty_list[targetIndex] = {
          sales_order_qty: balanceQty,
        };

        formValues.unit_price_list[targetIndex] = { unit_price: unitPrice };
        formValues.ship_qty_unit_list[targetIndex] = {
          ship_qty_unit: balanceQtyUnit,
        };
        formValues.balance_qty_unit_list[targetIndex] = {
          balance_qty_unit: balanceQtyUnit,
        };

        formValues.ship_qty_list[targetIndex] = { ship_qty: 0 };
        formValues.balance_qty_list[targetIndex] = { balance_qty: balanceQty };
        formValues.balance_value_list[targetIndex] = {
          balance_value: balanceQty * unitPrice,
        };
        formValues.ship_value_list[targetIndex] = { ship_value: 0 };

        poDetailsForm.setFieldsValue(formValues);
        return true;
      }
    }

    return false;
  };

  const getColorOptions = (styleId, index) => {
    if (isEditMode && salesContractDetails?.styleDetail?.length) {
      const styleDetail = salesContractDetails?.styleDetail?.find((sd) => sd?.style_info?.id === styleId);
      return (
        styleDetail?.style_info?.color_map?.map((c) => ({
          id: c.color_info?.id,
          name: c.color_info?.name,
        })) || []
      );
    }
    return colorOptions[index] || [];
  };

  const getSizeOptions = (index) => {
    if (isEditMode && salesContractDetails?.sales_contract?.size_info?.length) {
      return (
        salesContractDetails?.sales_contract?.size_info?.map((s) => ({
          id: s.sizes?.id,
          name: s.sizes?.name,
        })) || []
      );
    }
    return sizeOptions[index] || [];
  };

  return (
    <div className="">
      <Card
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span>Export PO Table</span>
            <Button
              onClick={toggleColorSizeColumns}
              size="small"
              type="default"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              {showColorSizeColumns ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              {showColorSizeColumns ? "Hide Color & Size" : "Show Color & Size"}
            </Button>
          </div>
        }
      >
        <div className="custome-table" style={{ paddingBottom: "20px" }}>
          <table border="1">
            <thead>
              <tr>
                <th colSpan={showColorSizeColumns ? 7 : 5} className="bc-orange text-center"></th>
                <th colSpan={4} className="bc-orange text-center border-left-right-black">
                  Shipment
                </th>
                <th colSpan={3} className="bc-orange text-center border-left-right-black">
                  Balance
                </th>
                {/* <th colSpan={1} className="bc-orange text-center border-left-right-black"></th> */}
                <th colSpan={2} className="bc-orange text-center">
                  Action
                </th>
              </tr>
              <tr>
                <th key="po_number" className="bc-java ">
                  PO Number
                </th>
                <th key="style_number" className="bc-java ">
                  Style Number
                </th>
                <th
                  key="color"
                  className="bc-java"
                  style={{
                    display: showColorSizeColumns ? "table-cell" : "none",
                  }}
                >
                  Color
                </th>
                <th
                  key="size"
                  className="bc-java"
                  style={{
                    display: showColorSizeColumns ? "table-cell" : "none",
                  }}
                >
                  Size
                </th>
                {/* {currentRole.name !== "Commercial & Shipping" && currentRole.name !== "Head of Commercial & Shipping" && (
                  <th key="style_number" className="bc-java ">
                  Sub Style Number
                </th>
                )} */}

                <th key="goods_description" className="bc-java ">
                  Goods Desc.
                </th>

                <th key="order_qty" className="bc-java ">
                  Order Qty.
                </th>
                <th key="unit_price" className="bc-java ">
                  Unit Price{" "}
                </th>
                <th key="carton_qty" className="bc-java border-left-black">
                  Carton Qty.
                </th>
                <th key="ship_qty" className="bc-java ">
                  Ship Qty.
                </th>
                <th key="ship_qty_unit" className="bc-java ">
                  Qty Unit.
                </th>
                <th key="ship_value" className="bc-java ">
                  Value
                </th>
                <th key="balance_qty" className="bc-java border-left-black">
                  Qty.
                </th>
                <th key="balance_qty_unit" className="bc-java ">
                  Qty. Unit
                </th>
                <th key="balance_value" className="bc-java border-right-black">
                  Value
                </th>
                {/* <th key="header_add_row" className="bc-java border-right-black">
                  Document
                </th> */}
                <th
                  key="header_add_row"
                  className="bc-java "
                  onClick={() => {
                    const newData = [...poDetailsData];
                    newData.push({
                      unique_id: newData.length > 0 ? newData[newData.length - 1].unique_id + 1 : 0,
                    });
                    setPoDetailsData(newData);
                  }}
                  style={{
                    cursor: "pointer",
                    color: "blue",
                    fontWeight: "bold",
                  }}
                >
                  Add
                </th>
                <th key="header_delete_row" className="bc-java ">
                  Delete
                </th>
              </tr>
            </thead>

            <tbody className="scrollable-table-container">
              {poDetailsData && poDetailsData?.length > 0 ? (
                <>
                  {poDetailsData.map((obj, index) => {
                    return (
                      <tr key={`table_parent_key_${index}`}>
                        <td className="t-body sticky" style={{ width: "10%" }}>
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: "Please Select PO Number!",
                              },
                            ]}
                            name={["po_numbers_list", index, "po_map_id"]}
                            style={{ marginBottom: "unset" }}
                          >
                            <Select
                              name={`internal_po_${obj?.unique_id}`}
                              dropdownStyle={{ minWidth: 50 }}
                              showSearch
                              placeholder="Select PO"
                              optionFilterProp="children"
                              filterOption={(input, option) => {
                                return option.children.toLowerCase().includes(input.toLowerCase());
                              }}
                              onChange={(value) => onSelectPO(value, index)}
                              size="small"
                              disabled={isView}
                            >
                              {salesContractDetails?.purchase_orders?.length &&
                                salesContractDetails?.purchase_orders?.map((poItem, index) => {
                                  return (
                                    <Option
                                      value={poItem.id || undefined}
                                      key={`internal_po_key_${index}`}
                                      disabled={poItem.is_fully_shipped === "Yes"}
                                    >
                                      {poItem?.original_po || poItem?.internal_po}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </td>
                        <td className="t-body sticky">
                          <Form.Item
                            rules={[
                              {
                                required: false,
                                message: "Please Select Style Number!",
                              },
                            ]}
                            name={["style_numbers_list", index, "style_id"]}
                            style={{ marginBottom: "unset" }}
                          >
                            {hasSubStyles ? (
                              // If we have sub-styles, show two selects
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "4px",
                                }}
                              >
                                {/* <Select
                                  name={`style_id_${obj?.style_id}`}
                                  dropdownStyle={{ minWidth: 50 }}
                                  value={obj?.style_id || undefined}
                                  showSearch
                                  placeholder="Select Style Number"
                                  onChange={(value) => {
                                    onSelectStyle(value, index, "style");
                                  }}
                                  optionFilterProp="children"
                                  filterOption={(input, option) => {
                                    if (option?.children != null) {
                                      return option.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase());
                                    }
                                    return false;
                                  }}
                                  size="small"
                                  disabled={isView}
                                >
                                  {salesContractDetails?.styleDetail?.length &&
                                    salesContractDetails?.styleDetail?.map(
                                      (contractItem, idx) => (
                                        <Option
                                          value={
                                            contractItem?.style_id || undefined
                                          }
                                          key={`style_id_key_${idx}`}
                                        >
                                          {contractItem?.style_info?.style_no}
                                        </Option>
                                      ),
                                    )}
                                </Select> */}

                                <Form.Item name={["sub_style_numbers_list", index, "sub_style_id"]} noStyle>
                                  <Select
                                    placeholder="Select Sub Style"
                                    showSearch
                                    onChange={(value) => onSelectStyle(value, index, "sub-style")}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => {
                                      if (option?.children != null) {
                                        return option.children.toLowerCase().includes(input.toLowerCase());
                                      }
                                      return false;
                                    }}
                                    size="small"
                                    disabled={isView}
                                    style={{ width: "100%" }}
                                  >
                                    {mergedSubStyles.map((subStyle, subIdx) => (
                                      <Option value={subStyle.id} key={`sub_style_id_${subIdx}`}>
                                        {subStyle.sub_style_no}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </div>
                            ) : (
                              // Original implementation if no sub-styles
                              <Select
                                name={`style_id_${obj?.style_id}`}
                                dropdownStyle={{ minWidth: 50 }}
                                value={obj?.style_id || undefined}
                                showSearch
                                placeholder="Select Style Number"
                                onChange={(value) => {
                                  if (value) {
                                    onStyleChange(value, index, "style");
                                    getSubstyle(value);
                                  }
                                }}
                                optionFilterProp="children"
                                filterOption={(input, option) => {
                                  if (option?.children != null) {
                                    return option.children.toLowerCase().includes(input.toLowerCase());
                                  }
                                  return false;
                                }}
                                size="small"
                                disabled={isView}
                              >
                                {salesContractDetails?.styleDetail?.length &&
                                  salesContractDetails?.styleDetail?.map((contractItem, idx) => (
                                    <Option value={contractItem?.style_id || undefined} key={`style_id_key_${idx}`}>
                                      {contractItem?.style_info?.style_no}
                                    </Option>
                                  ))}
                              </Select>
                            )}
                          </Form.Item>
                        </td>
                        <td
                          className="t-body"
                          style={{
                            display: showColorSizeColumns ? "table-cell" : "none",
                          }}
                        >
                          <Form.Item name={["color_list", index, "color_id"]} style={{ marginBottom: "unset" }}>
                            <Select
                              placeholder="Select Color"
                              size="small"
                              onChange={(value) => onColorChange(value, index)}
                              onClear={() => onClearColor(index)}
                              disabled={isView}
                              value={obj?.color_id || undefined}
                              style={{ width: 100 }}
                              allowClear
                            >
                              {getColorOptions(
                                poDetailsForm.getFieldsValue()?.style_numbers_list?.[index]?.style_id,
                                index,
                              ).map((color) => (
                                <Select.Option key={color.id} value={color.id}>
                                  {color.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </td>
                        <td
                          className="t-body"
                          style={{
                            display: showColorSizeColumns ? "table-cell" : "none",
                          }}
                        >
                          <Form.Item name={["size_list", index, "size_id"]} style={{ marginBottom: "unset" }}>
                            <Select
                              placeholder="Select Size"
                              size="small"
                              onChange={(value) => onSizeChange(value, index)}
                              onClear={() => onClearSize(index)}
                              disabled={isView}
                              value={obj?.size_id || undefined}
                              style={{ width: 80 }}
                              allowClear
                            >
                              {getSizeOptions(index).map((size) => (
                                <Select.Option key={size.id} value={size.id}>
                                  {size.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </td>
                        {currentRole.name !== "Commercial & Shipping" &&
                          currentRole.name !== "Head of Commercial & Shipping" && (
                            // <td className="t-body sticky">
                            //   <Form.Item
                            //     rules={[
                            //       {
                            //         required: false,
                            //         message: "Please Select Sub Style Number!",
                            //       },
                            //     ]}
                            //     name={[
                            //       "sub_style_numbers_list",
                            //       index,
                            //       "sub_style_id",
                            //     ]}
                            //     style={{ marginBottom: "unset" }}
                            //   >
                            //     <Select
                            //       name={`sub_style_id_${obj?.sub_style_id}`}
                            //       dropdownStyle={{ minWidth: 50 }}
                            //       // value={obj?.sub_style_id || undefined}
                            //       showSearch
                            //       placeholder="Select Sub Style Number"
                            //       optionFilterProp="children"
                            //       filterOption={(input, option) => {
                            //         if (option?.children != null) {
                            //           return option.children
                            //             .toLowerCase()
                            //             .includes(input.toLowerCase());
                            //         }
                            //       }}
                            //       size="small"
                            //       disabled={isView}
                            //     >
                            //       {isArrayAndHasValue(getSubstyleList(index)) &&
                            //         getSubstyleList(index)?.map(
                            //           (item, mapIndex) => {
                            //             return (
                            //               <Option
                            //                 value={item?.id || undefined}
                            //                 key={`style_id_key_${mapIndex}`}
                            //               >
                            //                 ${item?.sub_style_no || ""}
                            //               </Option>
                            //             );
                            //           },
                            //         )}
                            //     </Select>
                            //   </Form.Item>
                            // </td>
                            <></>
                          )}
                        <td className="t-body">
                          <Form.Item
                            name={["goods_description_list", index, "goods_description"]}
                            style={{ marginBottom: "unset" }}
                          >
                            <Select
                              size="small"
                              placeholder="Description of Goods"
                              mode="multiple"
                              style={{ width: 200 }}
                              showSearch
                              onSearch={(value) => getDescriptionsList({ description: value, per_page: 100 })}
                              optionFilterProp="label"
                              filterOption={(input, option) =>
                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                              }
                              onSelect={(value) => {
                                if (typeof setLcdetailsList === "function") {
                                  const context = "remarks";
                                  const reasons_data = Array.isArray(obj?.description)
                                    ? [...obj?.description]
                                    : [];
                                  reasons_data.push(value);
                                  onChangeLCValue(reasons_data, obj?.unique_id || index, context);
                                }
                              }}
                              disabled={isView}
                              onDeselect={(value) => {
                                if (typeof setLcdetailsList === "function") {
                                  const context = "remarks";
                                  const reasons_data = Array.isArray(obj?.description)
                                    ? [...obj?.description]
                                    : [];
                                  const filteredReasons = reasons_data.filter((item) => item !== value);
                                  onChangeLCValue(filteredReasons, obj?.unique_id || index, context);
                                }
                              }}
                              value={obj?.description || []}
                              dropdownRender={(menu) => (
                                <div>
                                  {menu}
                                  <Divider style={{ margin: "8px 0" }} />
                                  <Space style={{ padding: "0 8px 4px" }}>
                                    <Input
                                      placeholder="Description of Goods"
                                      size="small"
                                      value={addedGoodsDescription}
                                      onChange={onGoodsDescriptionChange}
                                    />
                                    <Button
                                      type="text"
                                      icon={<PlusOutlined />}
                                      size="small"
                                      onClick={addNewGoodsDescription}
                                    >
                                      Add
                                    </Button>
                                  </Space>
                                </div>
                              )}
                              options={goodsDescriptions?.map((item) => ({
                                label: item?.description || "",
                                value: item?.id,
                              }))}
                            />
                          </Form.Item>

                        </td>

                        <td className="t-body sticky">
                          <Form.Item
                            rules={[
                              {
                                required: false,
                                message: "Please Select Order Qty!",
                              },
                            ]}
                            name={["sales_order_qty_list", index, "sales_order_qty"]}
                            style={{ marginBottom: "unset" }}
                          >
                            <InputNumber
                              style={{ width: 100 }}
                              placeholder="Order Qty."
                              size="small"
                              disabled
                              precision={0}
                            />
                          </Form.Item>
                        </td>
                        <td className="t-body sticky">
                          <Form.Item
                            rules={[
                              {
                                required: false,
                                message: "Please Select Unit Price!",
                              },
                            ]}
                            name={["unit_price_list", index, "unit_price"]}
                            style={{ marginBottom: "unset" }}
                          >
                            <InputNumber
                              style={{ width: 100 }}
                              placeholder="Unit Price"
                              size="small"
                              disabled
                              precision={2}
                            />
                          </Form.Item>
                        </td>
                        <td className="t-body border-left-black">
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: "Please Input Carton Number.!",
                              },
                            ]}
                            name={["carton_qty_list", index, "carton_qty"]}
                            style={{ marginBottom: "unset" }}
                          >
                            <InputNumber
                              placeholder="Carton Qty."
                              onChange={(e) => onChangeCartonQty(e, index)}
                              size="small"
                              style={{ width: 100 }}
                              precision={0}
                              // temporary removed for entry purpose 
                              // disabled={
                              //   isView ||
                              //   !(poDetailsForm.getFieldValue("sales_order_qty_list")?.[index]?.sales_order_qty > 0)
                              // }
                            />
                          </Form.Item>
                        </td>
                        <td className="t-body ">
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: "Please Input Ship Qty.!",
                              },
                            ]}
                            name={["ship_qty_list", index, "ship_qty"]}
                            style={{ marginBottom: "unset" }}
                          >
                            <InputNumber
                              style={{ width: 100 }}
                              placeholder="Ship Qty."
                              onChange={(value) => onChangeShipQty(value, index)}
                              size="small"
                              precision={0}
                              // temporary removed for entry purpose 
                              // disabled={
                              //   isView ||
                              //   !(poDetailsForm.getFieldValue("sales_order_qty_list")?.[index]?.sales_order_qty > 0)
                              // }
                            />
                          </Form.Item>
                        </td>

                        <td className="t-body">
                          <Form.Item
                            name={["ship_qty_unit_list", index, "ship_qty_unit"]}
                            style={{ marginBottom: "unset" }}
                          >
                            <Select
                              placeholder="Ship Qty. Unit"
                              style={{ width: "100%" }}
                              size="small"
                              onSelect={(value) => onSelectShipmentUnit(value, index)}
                              // temporary removed for entry purpose 
                              // disabled={
                              //   isView ||
                              //   !(poDetailsForm.getFieldValue("sales_order_qty_list")?.[index]?.sales_order_qty > 0)
                              // }
                            >
                              {qtyUnit.map((option) => {
                                return (
                                  <option key={option.id} value={option.name}>
                                    {option?.name}
                                  </option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </td>
                        <td className="t-body">
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: "Please Input Ship Value!",
                              },
                            ]}
                            name={["ship_value_list", index, "ship_value"]}
                            style={{ marginBottom: "unset" }}
                          >
                            <InputNumber
                              style={{ width: 100 }}
                              placeholder="Ship Value"
                              size="small"
                              disabled
                              precision={2}
                              formatter={(value) => commaSeparateNumber(value)}
                            />
                          </Form.Item>
                        </td>
                        <td className="t-body border-left-black">
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: "Please Input Balance Qty.!",
                              },
                            ]}
                            name={["balance_qty_list", index, "balance_qty"]}
                            style={{ marginBottom: "unset" }}
                          >
                            <InputNumber style={{ width: 100 }} placeholder="Balance Qty." size="small" disabled />
                          </Form.Item>
                        </td>
                        <td className="t-body">
                          <Form.Item
                            name={["balance_qty_unit_list", index, "balance_qty_unit"]}
                            style={{ marginBottom: "unset" }}
                          >
                            <Select
                              placeholder="Balance Qty. Unit"
                              style={{ width: "100%" }}
                              size="small"
                              // temporary removed for entry purpose 
                              // disabled={
                              //   isView ||
                              //   !(poDetailsForm.getFieldValue("sales_order_qty_list")?.[index]?.sales_order_qty > 0)
                              // }
                            >
                              {qtyUnit.map((option) => {
                                return (
                                  <option key={option.id} value={option.name}>
                                    {option?.name}
                                  </option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </td>
                        <td className="t-body border-right-black">
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: "Please Input Balance Value!",
                              },
                            ]}
                            name={["balance_value_list", index, "balance_value"]}
                            style={{ marginBottom: "unset" }}
                          >
                            <InputNumber
                              style={{ width: 100 }}
                              placeholder="Balance Value"
                              size="small"
                              disabled
                              precision={2}
                              formatter={(value) => commaSeparateNumber(value)}
                            />
                          </Form.Item>
                        </td>
                        {/* <td className="t-body border-right-black">
                        <Space>
                          <Upload
                            action={
                              api_base_url +
                              EXPORT_DETAILS_DOC_UPLOAD
                            }
                            accept="image/*,.pdf, .doc, .xlsx"
                            headers={{
                              authorization: `Bearer ${token}`,
                            }}
                            showUploadList={false}
                            onChange={(info) => onChangeFileUpload(info, index)}
                          >
                            <Button
                              type="primary"
                              icon={<CloudUploadOutlined />}
                              size="small"
                              // disabled={view}
                            />
                          </Upload>
                          {(obj?.document) && (
                            <Button
                              icon={<EyeOutlined />}
                              size="small"
                              onClick={() =>
                                openFileInNewTab(obj?.document)
                              }
                              // disabled={view}
                            />
                          )}
                        </Space>
                        </td> */}
                        <td
                          className="t-body"
                          onClick={() => {
                            if (!isView) {
                              copyRow(obj?.unique_id);
                            }
                          }}
                        >
                          <Form.Item style={{ marginBottom: "unset" }}>
                            <Tooltip title="Add Row">
                              <PlusCircleOutlined style={{ fontSize: "16px", color: "Green" }} />
                            </Tooltip>
                          </Form.Item>
                        </td>
                        <td
                          className="t-body"
                          onClick={() => {
                            if (!isView) {
                              removeRow(obj?.unique_id);
                            }
                          }}
                        >
                          <Form.Item style={{ marginBottom: "unset" }}>
                            <Tooltip title="Remove Row">
                              <MinusCircleOutlined style={{ fontSize: "16px", color: "red" }} />
                            </Tooltip>
                          </Form.Item>
                        </td>
                      </tr>
                    );
                  })}
                </>
              ) : (
                ""
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
};

export default ExportPOTable;
